import api from 'service/api'

import { CommunityOption, ChangeDefaultCommunityResult, readChangeResult, toCommunityOptions } from './defaultCommunity'

export const fetchCommunityOptions = async (): Promise<CommunityOption[]> =>
  toCommunityOptions(await api.getManageCommunities())

export const changeDefaultCommunity = async (
  userId: number,
  communityId: number,
): Promise<ChangeDefaultCommunityResult> =>
  readChangeResult(await api.changeUserDefaultCommunity(userId, communityId), communityId)
